/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-27 16:59:29
 * @Last Modified by: LoongKing
 * @Last Modified time: 2018-01-26 20:07:55
 *
 * [街道数据](https://github.com/mumuy/data_location)
 * [省市县级数据](https://github.com/cn/GB2260.js)
 * 此模块虽然做了大量的功能封装，但还是有较多的耦合，以后编写函数时，函数仅是入口，所有要操作的数据，只能以参数的形式传递和调用，不操作外部数据变量。
 */

var hs = hs || {};


hs.area2 = function (param) {
    param = param || {};
    // 模拟下拉框形式，选项卡切换模式
    this.model = param.model || 'select'; // 'select', 'tab'
    // 入口
    this.container = param.container ? param.container : param.model === "select" ? '[data-area-model="select"]' : '[data-area-model="tab"]';

    // 显示结果
    this.result = param.result || '[data-area="result"]';

    // 触发标签
    this.triggerClass = param.triggerClass || ".select-area-item";
    this.triggerActiveClass = param.triggerActiveClass || "select-area-item-active";
    this.triggerEnableClass = param.triggerEnableClass || "select-area-item-enable";
    this.triggerDisableClass = param.triggerDisableClass || "select-area-item-disable";
    this.triggerHiddenClass = param.triggerHiddenClass || "hidden";

    this.provinceTrigger = param.provinceTrigger || '[data-area-item="provinces"]';
    this.prefectureTrigger = param.prefectureTrigger || '[data-area-item="prefectures"]';
    this.countyTrigger = param.countyTrigger || '[data-area-item="counties"]';
    // trigger字符是否根据选择替换，选项卡模式时不用替换，下拉框模式要替换
    this.triggerReplace = (typeof param.triggerReplace === 'undefined') ? true : param.triggerReplace;

    // 触发标签获取相应名
    this.placeholder = param.placeholder || '[data-area="name"]';
    // 预占位
    this.placeholderAll = param.placeholderAll || "全国";
    this.placeholderProvince = param.placeholderProvince || "省份"; // 省的预占位直接在HTML模板提前做好，下拉选择后就再也不会出现
    this.placeholderPrefecture = param.placeholderPrefecture || "市级";
    this.placeholderCounty = param.placeholderCounty || "县级";

    // 相关数据面板
    this.panelClass = param.panelClass || '.select-area-panel';
    this.panelActiveClass = param.panelActiveClass || 'select-area-panel-active';
    this.provincePanel = param.provincePanel || '[data-area-panel="provinces"]';
    this.prefecturePanel = param.prefecturePanel || '[data-area-panel="prefectures"]';
    this.countyPanel = param.countyPanel || '[data-area-panel="counties"]';

    // 默认激活项，或将操作信息返回
    this.activeProvince = "";
    this.activePrefecture = "";
    this.activeCounty = "";
    this.activeCode = param.activeCode || ""; // 不区分级别进行拆解识别
    this.activeProvinceCode = param.activeProvinceCode || "";
    this.activePrefectureCode = param.activePrefectureCode || "";
    this.activeCountyCode = param.activeCountyCode || "";

    // 数据项列表标签类型、类名、激活类名
    this.optionType = param.optionType || 'li';
    this.optionClass = param.optionClass || 'area-item';
    this.optionActiveClass = param.optionActiveClass || 'area-item-active';

    // 最后的选择结果
    this.done = false;
    this._result = "";
    // 是否合并层级选择结果：如“湖南/长沙市/岳麓区”，false仅展示最后选择的区域，如“岳麓区”
    this.resultJoint = (typeof param.resultJoint === 'undefined') ? true : param.resultJoint;
    this.resultSpliceChar = param.resultSpliceChar || '/';

    // 是否必须选一个
    this.required = param.required || true;

    // 是否从json加载省级数据，因为涉及到按首字母归类或手动排序用户自行拼接成html模板
    this.provinceExist = (typeof param.provinceExist === 'undefined') ? false : param.provinceExist;
    // 去除'省'/'市'/'自治区'/'特别行政区'字符
    this.ignoreProvince = (typeof param.ignoreProvince === 'undefined') ? false : param.ignoreProvince;
    // 暂时过滤掉港澳台地区
    this.ignoreGangAoTai = (typeof param.ignoreGangAoTai === 'undefined') ? true : param.ignoreGangAoTai;
    // 暂时过滤掉第三级行政区域辖级/城区
    this.ignoreCounty = (typeof param.ignoreCounty === 'undefined') ? false : param.ignoreCounty;
    // 直辖市地区是否移除对应市级面板
    this.destroyPrefecture = (typeof param.destroyPrefecture === 'undefined') ? false : param.destroyPrefecture;
    // 部分市级筛选过滤后暂无县级信息，是否移除对应县级面板和触发
    this.destroyCounty = (typeof param.destroyCounty === 'undefined') ? true : param.destroyCounty;

};

hs.area2.prototype.init = function () {

    //#region option
    var _this = this;
    if (_this.model !== "tab" && _this.model !== "select") {
        return;
    }

    var $container = $(_this.container);
    var $result = $container.find(_this.result);

    var $trigger = $container.find(_this.triggerClass);
    var $provinceTrigger = $container.find(_this.provinceTrigger);
    var provinceTriggerLength = $provinceTrigger.length;
    var $prefectureTrigger = $container.find(_this.prefectureTrigger);
    var prefectureTriggerLength = $prefectureTrigger.length;
    var $countyTrigger = $container.find(_this.countyTrigger);
    var countyTriggerLength = $countyTrigger.length;

    var $provinceTriggerName = $provinceTrigger.find(_this.placeholder);
    var $prefectureTriggerName = $prefectureTrigger.find(_this.placeholder);
    var $countyTriggerName = $countyTrigger.find(_this.placeholder);

    var $panel = $container.find(_this.panelClass);
    var $provincePanel = $container.find(_this.provincePanel);
    var provincePanelLength = $provincePanel.length;
    var $prefecturePanel = $container.find(_this.prefecturePanel);
    var prefecturePanelLength = $prefecturePanel.length;
    var $countyPanel = $container.find(_this.countyPanel);
    var countyPanelLength = $countyPanel.length;
    //#endregion

    // 触发项不是必需项，面板项是必需项；
    // 面板项可以配合触发项通过样式做成类下拉选择的效果，交互效果更丰富；
    // 面板项可以独立存在，展示区域列表信息；


    // gb2260.js 使用:https://github.com/cn/GB2260.js/blob/develop/dist/gb2260.js，并将 es5 语法部分修改成了 underscore.js 的方法

    var gb = new gb2260.GB2260({
        data: HS_AREA_DATA
    });

    //#region 获取数据

    /**
     * 获取所有省级数据
     * @returns - 省级数据数组
     */
    function getProvinces() {
        return gb.provinces();
    }

    /**
     * 根据省级获取市级
     * @param {any} code - 省级区域编码(例如:430000)
     * @returns - 市级数据数组
     */
    function getPrefectures(code) {
        return gb.prefectures(code);
    }

    /**
     * 根据市级获取县级
     * @param {string} code - 市级区域编码(例如:433100)
     * @returns - 县级数据数组
     */
    function getCounties(code) {
        return gb.counties(code);
    }

    /**
     * 根据区域编码获取相关数据
     * @param {string} code - 区域编码
     * @returns 相关数据
     */
    function get(code) {
        return gb.get(code);
    }

    //#endregion

    /**
     * 生成模板
     * @param {object} param - \{data:面板数据, $inner:面板\}
     */
    function setData(param) {
        if (param.$panel.length) {
            var $panel = param.$panel;
            var data = param.data;
            var dataLength = data.length;
            var type = param.type || 'province'; // 数据种类'province', 'prefecture', 'county'
            var clear = (typeof param.clear === 'undefined') ? true : param.clear;
            var tpl = [];
            var tempName = "";
            var tempCode = "";
            for (var i = 0; i < dataLength; i++) {

                tempName = data[i].name;
                tempCode = data[i].code;

                if (type === "province" && _this.ignoreProvince) {
                    // 按需过滤到'省'/'市'/'自治区'/'特别行政区'
                    tempName = tempName.replace(/维吾尔自治区|回族自治区|壮族自治区|自治区|特别行政区|省|市/, "");
                } else if (type === "prefecture") {
                    tempName = (tempName === "省直辖县级行政区划") ? "省直辖" : tempName;
                } else if (type === "county" && _this.ignoreCounty) {
                    if (tempName === "城区" || tempName === "市辖区") {
                        continue;
                    }
                }
                // 是否暂时过滤掉港澳台地区
                if (type === "province" && _this.ignoreGangAoTai) {
                    if (tempCode === "710000" || tempCode === "810000" || tempCode === "820000") {
                        continue;
                    }
                }
                tpl.push('<' + _this.optionType + ' class="' + _this.optionClass + '" data-val="' + tempCode + '" data-name="' + tempName + '">' + tempName + '</' + _this.optionType + '>');
            }
            if (clear) {
                $panel.html('');
            }
            $panel.append(tpl);
        }
    }

    //#region 设置数据面板

    /** 给面板选(设)定项加激活样式 */
    function setPanelItem(param) {
        param.$panel.find('.' + _this.optionClass + '[data-val=' + param.code + ']').addClass(_this.optionActiveClass);
    }

    /** 设置省级数据面板 */
    function setProvincePanel() {
        if (provincePanelLength) {
            !(_this.provinceExist) && setData({
                $panel: $provincePanel,
                data: getProvinces(),
                type: 'province'
            });
            triggerEnable($provinceTrigger);
            if (_this.model === "tab") {
                triggerActive($provinceTrigger);
            }
        }
    }

    /** 直辖市地区特殊处理 */
    function specialProvince() {
        return _this.activeProvinceCode === "110000" || _this.activeProvinceCode === "120000" || _this.activeProvinceCode === "310000" || _this.activeProvinceCode === "500000";
    }
    /** 港澳台 */
    function specialProvince2() {
        return _this.activeProvinceCode === "710000" || _this.activeProvinceCode === "810000" || _this.activeProvinceCode === "820000";
    }

    /** 设置市级数据面板 */
    function setPrefecturePanel() {
        if (countyPanelLength) {
            if (specialProvince()) {
                // 重置市级
                _this.activePrefecture = _this.placeholderPrefecture;
                _this.activePrefectureCode = _this.activeProvinceCode.slice(0, 2) + '0100';
                $prefectureTrigger.attr('area-prefecture-code', _this.activePrefectureCode);
                $prefecturePanel.html('<' + _this.optionType + ' class="' + _this.optionClass + ' ' + _this.optionActiveClass + '" data-val="' + _this.activePrefectureCode + '" data-text="' + _this.activePrefecture + '">' + _this.activePrefecture + '</' + _this.optionType + '>');
            } else if (!(_this.ignoreGangAoTai) && specialProvince2()) {
                // 港澳台地区隐藏
                triggerHidden($prefectureTrigger);
                triggerHidden($countyTrigger);
            } else {
                setData({
                    $panel: $prefecturePanel,
                    data: getPrefectures(_this.activeProvinceCode),
                    type: 'prefecture'
                });
            }

            // 面板创建完成，如果有默认设置项，则初始之
            if (_this.activePrefectureCode) {
                setPanelItem({
                    $panel: $prefecturePanel,
                    code: _this.activePrefectureCode
                });
            }
        }
    }

    /** 设置县级数据面板 */

    /** 过滤后没有县级数据，隐藏掉 */
    function countyDestroy() {
        if (!($countyPanel.find('.' + _this.optionClass).length)) {
            triggerHidden($countyTrigger);
            return true;
        }
    }

    function setCountyPanel() {
        if (countyPanelLength && _this.activePrefectureCode) {
            setData({
                $panel: $countyPanel,
                data: getCounties(_this.activePrefectureCode),
                type: 'county'
            });

            // 如果是重庆，合并市县级
            if (_this.activeProvinceCode === "500000") {
                setData({
                    $panel: $countyPanel,
                    data: getCounties(_this.activeProvinceCode.slice(0, 2) + '0200'),
                    type: 'county',
                    clear: false
                });
            }

            // 面板创建完成，如果有默认设置项，则初始之
            if (_this.activeCountyCode) {
                setPanelItem({
                    $panel: $countyPanel,
                    code: _this.activeCountyCode
                });
            }
        }
    }
    //#endregion

    //#region 设置触发项

    /** 设置触发项，只能操作dom上的数据，不能操作其状态，因为操作结尾不定，trigger状态不明，状态由专门控制状态的机制处理 */
    function setTrigger(param) {
        if (param.$trigger.length) {
            param.$trigger.attr(param.attrKey, param.attrValue);
            _this.triggerReplace && param.$triggerName.text(param.info);
        }
    }

    /** 设置省级触发项 */
    function setProvinceTrigger() {
        setTrigger({
            $trigger: $provinceTrigger,
            attrKey: "area-province-code",
            attrValue: _this.activeProvinceCode,
            $triggerName: $provinceTriggerName,
            info: _this.activeProvince
        });
        // 铁定有了省级id，市级触发就可用
        triggerEnable($prefectureTrigger);
    }

    /** 设置市级触发项 */
    function setPrefectureTrigger() {
        setTrigger({
            $trigger: $prefectureTrigger,
            attrKey: "area-prefecture-code",
            attrValue: _this.activePrefectureCode,
            $triggerName: $prefectureTriggerName,
            info: _this.activePrefecture
        });
        // 铁定有了市级id，县级触发就可用
        triggerEnable($countyTrigger);
    }

    /** 设置县级触发项 */
    function setCountyTrigger() {
        setTrigger({
            $trigger: $countyTrigger,
            attrKey: "area-county-code",
            attrValue: _this.activeCountyCode,
            $triggerName: $countyTriggerName,
            info: _this.activeCounty
        });
    }
    //#endregion

    //#region 选择结束

    /** 根据选择实时显示结果 */
    function setResult(code, text) {
        if ($result.length) {
            _this._result = "";
            if (_this.activeProvince) {
                _this.resultJoint ? _this._result = _this.activeProvince : _this._result = '[' + _this.activeProvince + ']';
            }
            if (_this.activePrefecture && !(specialProvince())) {
                _this.resultJoint ? _this._result += _this.resultSpliceChar + _this.activePrefecture : _this._result = '[' + _this.activePrefecture + ']';
            }
            if (_this.activeCounty) {
                _this.resultJoint ? _this._result += _this.resultSpliceChar + _this.activeCounty : _this._result = '[' + _this.activeCounty + ']';
            }

            $result.text(_this._result).attr("data-area-code", code).attr("data-area-text", text);
        }
    }

    /** 最后完成操作 */
    function complete($trigger, $panel) {
        if (_this.model === "select") {
            // 收起下拉
            triggerToggle($trigger, $panel);
        } else if (_this.model === "tab") {
            // 关闭整个弹出
            $container.removeClass('dorpdown-active dorpdown-keep');
        }
    }
    //#endregion

    //#region 触发项开关基础操作

    /**
     * 触发项开关
     * @param {object} _$item - 触发项
     * @param {object} _$panel - 触发面板
     */
    function triggerToggle(_$item, _$panel) {
        if (_$item.length && _$item.hasClass(_this.triggerActiveClass) || _$panel.length && _$panel.hasClass(_this.panelActiveClass)) {
            _$item.removeClass(_this.triggerActiveClass);
            _$panel.removeClass(_this.panelActiveClass);
        } else {
            active(_$item, _$panel);
        }
    }

    function active(_$item, _$panel) {
        triggerActive(_$item);
        $panel.removeClass(_this.panelActiveClass); // 所有面板移除激活
        _$panel.addClass(_this.panelActiveClass); // 激活当前指定面板
    }

    /**
     * 触发项的激活状态(active)
     * @param {object} $item - jQuery对象
     */
    function triggerActive($item) {
        if ($item.length) {
            $item.addClass(_this.triggerActiveClass).siblings(_this.triggerClass).removeClass(_this.triggerActiveClass);
        }
    }

    /**
     * 触发项的可用状态(enable)
     * @param {object} $item
     */
    function triggerEnable($item) {
        if ($item.length) {
            $item.addClass(_this.triggerEnableClass).removeClass(_this.triggerDisableClass).removeClass(_this.triggerHiddenClass);
        }
    }

    /**
     * 触发项的禁用状态(disable)
     * @param {object} $item
     */
    function triggerDisable($item) {
        if ($item.length) {
            $item.addClass(_this.triggerDisableClass).removeClass(_this.triggerEnableClass).removeClass(_this.triggerHiddenClass);
        }
    }

    /**
     * 触发项的隐藏状态(hidden)，直辖市
     * @param {object} $item
     */
    function triggerHidden($item) {
        if ($item.length) {
            $item.addClass(_this.triggerHiddenClass).removeClass(_this.triggerEnableClass).removeClass(_this.triggerActiveClass);
        }
    }
    //#endregion

    //#region 选择变化后重置
    /**
     * 选择变化后重置触发项和面板数据，
     * @param {object} param  - \{$trigger:触发项, attrKey:触发项data属性名, attrValue:触发项data属性值, $triggerName:触发项名, info:触发项名文本信息, $panel:面板类型\}
     */
    function reset(param) {
        if (param.$trigger.length) {
            param.$trigger.attr(param.attrKey, param.attrValue);
            _this.triggerReplace && param.$triggerName.text(param.info);
        }
        if (param.$panel.length) {
            param.$panel.html("");
        }
    }

    /** 如果是直辖市，或者点击了常规市级行政区域，重置县级数据 */
    function cleanCounty() {
        _this.activeCounty = "";
        _this.activeCountyCode = "";
        reset({
            $trigger: $countyTrigger,
            attrKey: "area-county-code",
            attrValue: "",
            $triggerName: $countyTriggerName,
            info: _this.placeholderCounty,
            $panel: $countyPanel
        });
    }

    function resetCounty() {
        _this.activeCounty = "";
        _this.activeCountyCode = "";
        reset({
            $trigger: $countyTrigger,
            attrKey: "area-county-code",
            attrValue: "",
            $triggerName: $countyTriggerName,
            info: "市区",
            $panel: $countyPanel
        });
        setCountyPanel();
        triggerEnable($countyTrigger);
        triggerToggle($countyTrigger, $countyPanel);
    }
    //#endregion

    /* ==== 相关操作==== */

    // 管它的，都先禁用
    $trigger.addClass(_this.triggerDisableClass);

    //#region 有指定激活项，初始默认结果

    setProvincePanel();


    // 结果项上是否有保存数据
    var _resultCode = $result.attr('data-area-code');
    if (_resultCode) {
        _this.activeCode = _resultCode;
    }

    // 对默认激活项进行拆分
    if (_this.activeCode) {
        _this.activeProvinceCode = _this.activeCode.substr(0, 2) + "0000";
        if (_this.activeCode.substr(2, 2) !== "00") {
            _this.activePrefectureCode = _this.activeCode.substr(0, 4) + "00";
        }
        if (_this.activeCode.substr(4, 2) !== "00") {
            _this.activeCountyCode = _this.activeCode;
        }
    }

    if (_this.activeCountyCode) {
        // 如果有默认县级行政区域
        var countyTemp = get(_this.activeCountyCode); // 这里已经get到三级数据，所以下面是else if分支
        _this.activeProvince = countyTemp.province.name;
        _this.activeProvinceCode = countyTemp.province.code;
        _this.activePrefecture = countyTemp.prefecture.name;
        _this.activePrefectureCode = countyTemp.prefecture.code;
        _this.activeCounty = countyTemp.name;
        _this.activeCountyCode = countyTemp.code;

        setProvinceTrigger();
        setPrefectureTrigger();
        setCountyTrigger();

        setPrefecturePanel();
        setCountyPanel();

        if (_this.model === "tab") {
            active($countyTrigger, $countyPanel);
        }

        setResult(_this.activeCountyCode, _this.activeCounty);
    } else if (_this.activePrefectureCode) {
        // 如果有默认市级行政区域
        var prefectureTemp = get(_this.activePrefectureCode);
        _this.activeProvince = prefectureTemp.province.name;
        _this.activeProvinceCode = prefectureTemp.province.code;
        _this.activePrefecture = prefectureTemp.name;
        _this.activePrefectureCode = prefectureTemp.code;

        setProvinceTrigger();
        setPrefectureTrigger();

        setPrefecturePanel();
        setCountyPanel();

        // 直辖市直接到县级
        if (specialProvince()) {
            (_this.model === "tab") && active($countyTrigger, $countyPanel);
            setResult(_this.activeProvinceCode, _this.activeProvince);
        } else {
            _this.destroyCounty && countyDestroy();
            (_this.model === "tab") && active($prefectureTrigger, $prefecturePanel);
            setResult(_this.activePrefectureCode, _this.activePrefecture);
        }
    } else if (_this.activeProvinceCode) {
        // 如果有默认省级行政区域
        var provinceTemp = get(_this.activeProvinceCode);
        _this.activeProvince = provinceTemp.name;
        _this.activeProvinceCode = provinceTemp.code;
        setProvinceTrigger();
        setPrefecturePanel();
        (_this.model === "tab") && active($provinceTrigger, $provincePanel);
        setResult(_this.activeProvinceCode, _this.activeProvince);
    }

    // 因为 activeProvinceCode 是通过其子项往上追溯而来，所以要放置在这里
    if (_this.activeProvinceCode) {

        // 面板创建完成，如果有默认设置项，则初始之
        setPanelItem({
            $panel: $provincePanel,
            code: _this.activeProvinceCode
        });
    }
    //#endregion

    //#region 无指定激活项，初始默认结果

    /* 初始显示默认结果 */
    if (!(_this.activeProvinceCode || _this.activePrefectureCode || _this.activeCountyCode)) {
        $result.text(_this.placeholderAll);
    }

    !(_this.activeProvinceCode) && setTrigger({
        $trigger: $provinceTrigger,
        attrKey: "area-province-code",
        attrValue: "",
        $triggerName: $provinceTriggerName,
        info: _this.placeholderProvince
    });

    // 上一级无激活，本级需重置
    !(_this.activePrefectureCode) && !(_this.activeProvinceCode) && reset({
        $trigger: $prefectureTrigger,
        attrKey: "area-prefecture-code",
        attrValue: "",
        $triggerName: $prefectureTriggerName,
        info: _this.placeholderPrefecture,
        $panel: $prefecturePanel
    });

    // 上一级无激活，本级需重置
    !(_this.activeCountyCode) && !(_this.activeProvinceCode) && reset({
        $trigger: $countyTrigger,
        attrKey: "area-county-code",
        attrValue: "",
        $triggerName: $countyTriggerName,
        info: _this.placeholderCounty,
        $panel: $countyPanel
    });
    //#endregion

    //#region 触发项(trigger)点击事件
    // 反正是顶级省级数据，什么都别说，就一个字：干

    provinceTriggerLength && $provinceTrigger.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // triggerToggle($provinceTrigger, $provincePanel);
        active($provinceTrigger, $provincePanel);
    });
    // 有没有默认激活市级
    prefectureTriggerLength && $prefectureTrigger.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass("select-area-item-disable")) {
            return;
        }
        // triggerToggle($prefectureTrigger, $prefecturePanel);
        active($prefectureTrigger, $prefecturePanel);
    });
    // 有没有默认激活县级
    countyTriggerLength && $countyTrigger.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass("select-area-item-disable")) {
            return;
        }
        // triggerToggle($countyTrigger, $countyPanel);
        active($countyTrigger, $countyPanel);
    });
    //#endregion

    //#region 面板(panel)选择事件
    // 面板上的子项点击时添加激活样式
    $panel.on('click', '.' + _this.optionClass, function () {
        var $this = $(this);
        var _$tempPanel = $this.parents(_this.panelClass);
        _$tempPanel.find('.' + _this.optionClass).removeClass(_this.optionActiveClass);
        $this.addClass(_this.optionActiveClass);
    });

    // 省份面板点击
    provincePanelLength && $provincePanel.on('click', '.' + _this.optionClass, function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);

        // 把选择的数据传出去
        _this.activeProvinceCode = $this.data("val") + "";
        _this.activeProvince = $this.text();
        _this.done = false;

        // 好扯，有的高度改变会引发鼠标经过事件，导致鼠标移出，面板隐藏
        (_this.model === "tab") && $container.addClass('dorpdown-active dorpdown-keep');

        // 设置省级视图
        setProvinceTrigger();

        // 重置市级
        _this.activePrefecture = "";
        _this.activePrefectureCode = "";

        reset({
            $trigger: $prefectureTrigger,
            attrKey: "area-prefecture-code",
            attrValue: "",
            $triggerName: $prefectureTriggerName,
            info: _this.placeholderPrefecture,
            $panel: $prefecturePanel
        });

        // 设置市级面板
        setPrefecturePanel();

        if (specialProvince()) {
            // 直辖市，重置并初始县级，并跳转到县级
            triggerToggle($provinceTrigger, $provincePanel);
            resetCounty();
            _this.destroyPrefecture && triggerHidden($prefectureTrigger);
        } else if (!(_this.ignoreGangAoTai) && specialProvince2()) {
            // 港澳台，完结操作
            triggerHidden($prefectureTrigger);
            triggerHidden($countyTrigger);
            cleanCounty();
            _this.done = true;
            complete($provinceTrigger, $provincePanel);
        } else {
            // 常规省市切换
            triggerToggle($provinceTrigger, $provincePanel);
            triggerEnable($prefectureTrigger);
            triggerToggle($prefectureTrigger, $prefecturePanel);
            cleanCounty();
            triggerDisable($countyTrigger);
        }

        // 实时显示选择结果
        setResult(_this.activeProvinceCode, _this.activeProvince);
    });
    // 市级面板点击
    prefecturePanelLength && $prefecturePanel.on('click', '.' + _this.optionClass, function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);

        // 把选择的数据传出去
        _this.activePrefectureCode = $this.data("val") + "";
        _this.activePrefecture = $this.text();
        _this.done = false;

        // 设置市级视图
        setPrefectureTrigger();

        cleanCounty();
        setCountyPanel();

        if (_this.destroyCounty && countyDestroy()) {
            // 过滤部分地址后无数据状态，完结操作
            _this.done = true;
            complete($prefectureTrigger, $prefecturePanel);
        } else {
            triggerToggle($prefectureTrigger, $prefecturePanel);
            triggerEnable($countyTrigger);
            triggerToggle($countyTrigger, $countyPanel);
            (_this.model === "tab") && $container.addClass('dorpdown-active dorpdown-keep');
        }
        // 实时显示选择结果
        setResult(_this.activePrefectureCode, _this.activePrefecture);
    });
    // 县级面板点击
    countyPanelLength && $countyPanel.on('click', '.' + _this.optionClass, function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);

        // 把选择的数据传出去
        _this.activeCountyCode = $this.data("val") + "";
        _this.activeCounty = $this.text();

        // 实时显示选择结果
        setResult(_this.activeCountyCode, _this.activeCounty);

        // 设置县级
        setCountyTrigger();
        _this.done = true;
        complete($countyTrigger, $countyPanel);
    });
    //#endregion

    $('body').on('click', function (event) {
        var selected = ($trigger.hasClass(_this.triggerActiveClass) && _this.model === "select");
        if (event.target.className.indexOf(_this.panelClass) === -1 && selected) {
            $trigger.removeClass(_this.triggerActiveClass);
            $panel.removeClass(_this.panelActiveClass);
        }
        setPanelItem({
            $panel: $prefecturePanel,
            code: _this.placeholderAll
        });
    });


};